import {calculateErrorMessage} from 'common/helpers'

import type {WalkthroughStep} from '../core/DynamicWalkthroughContext'

export function parseApiResponse(response: any): WalkthroughStep[] {
  try {
    const walkthrough = response?.result?.walkthrough || response?.walkthrough || []
    if (!Array.isArray(walkthrough)) return []

    return walkthrough
      .filter((step: any) => step?.id && step?.walkthrough)
      .map((step: any) => ({
        // preserve original path so per-step navigation can work
        path: step.path || '',
        id: step.id,
        order: step.order || 0,
        walkthrough: {
          target: step.walkthrough.target || '',
          title: step.walkthrough.title || 'Step',
          content: step.walkthrough.content || '',
          position: step.walkthrough.position || 'bottom',
          highlightType: step.walkthrough.highlightType || 'border',
          action: step.walkthrough.action || 'none',
          scroll: step.walkthrough.scroll || 'auto',
          stepType: step.walkthrough.stepType || 'info',
          tooltipMode: step.walkthrough.tooltipMode,
          permission: step.walkthrough.permission,
          completion: step.walkthrough.completion
            ? {
                type: step.walkthrough.completion.type,
                target: step.walkthrough.completion.target,
                timeout: step.walkthrough.completion.timeout,
              }
            : undefined,
        },
      }))
      .sort((a: any, b: any) => a.order - b.order)
  } catch (error) {
    calculateErrorMessage(error)
    return []
  }
}

export function inferTooltipMode(step: WalkthroughStep): 'blocking' | 'interactive' {
  try {
    const w = step.walkthrough
    if (w.tooltipMode) return w.tooltipMode

    if (w.action === 'click') return 'blocking'
    if (w.highlightType === 'spotlight') return 'blocking'
    if (w.action === 'input' || w.action === 'hover') return 'interactive'
    if (w.stepType === 'info') return 'interactive'

    return 'blocking'
  } catch (e) {
    calculateErrorMessage(e)
    return 'blocking'
  }
}
